import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-page" }
const _hoisted_2 = { class: "login-box" }
const _hoisted_3 = { class: "card card-outline card-primary" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "Exoty", -1)
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-mobile-alt fa-3x text-primary" })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h5", { class: "text-center mb-2" }, "Two-Factor Authentication", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "login-box-msg" }, "Enter the 6-digit verification code from your email", -1)
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_input = _resolveComponent("app-input")!
  const _component_app_button = _resolveComponent("app-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "card-header text-center h1"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _createElementVNode("form", {
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.verify && _ctx.verify(...args)), ["prevent"]))
          }, [
            _createVNode(_component_app_input, {
              class: "mb-3",
              placeholder: "000000",
              modelValue: _ctx.model.mfaCode,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.mfaCode) = $event)),
              validations: _ctx.v$.mfaCode
            }, null, 8, ["modelValue", "validations"]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_app_button, {
                  name: "Verify",
                  theme: "primary",
                  class: "btn-block",
                  onClick: _withModifiers(_ctx.verify, ["prevent"])
                }, null, 8, ["onClick"])
              ])
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}